var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnoncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "annoncement"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29383",
    "data-name": "Rectangle 29383",
    width: 16,
    height: 16,
    transform: "translate(26 492)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_713",
    "data-name": "Mask Group 713",
    transform: "translate(-26 -492)",
    clipPath: "url(#annoncement)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_64_",
    "data-name": "svgexport-6 (64)",
    transform: "translate(26 492.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M4.28,9.632a.312.312,0,1,0-.427-.114A.313.313,0,0,0,4.28,9.632Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M3,11.789l1.574,2.726a1.25,1.25,0,1,0,2.165-1.25L5.8,11.641l.812-.469a.313.313,0,0,0,.114-.427l-.406-.7,5.986-1.174a.937.937,0,0,0,.76-1.4l-1.039-1.8.664-1.005a.313.313,0,0,0,.01-.328l-.625-1.083a.313.313,0,0,0-.289-.156l-1.2.072-1.153-2A.929.929,0,0,0,8.631.7H8.619a.929.929,0,0,0-.789.432l-4.082,5.2L1.094,7.864A2.187,2.187,0,0,0,3,11.789Zm3.2,1.789a.625.625,0,0,1-1.083.625L3.552,11.5l1.083-.625L6.2,13.578ZM5.488,11.1l-.312-.541.541-.312.313.541Zm6.143-7.372.432.748-.385.583L10.934,3.77ZM8.353,1.474a.312.312,0,0,1,.537.006l3.635,6.3a.312.312,0,0,1-.263.469,1.147,1.147,0,0,0-.171.029L8.246,1.614c.081-.1.091-.114.107-.14Zm-.523.67L11.442,8.4,5.99,9.47,4.333,6.6Zm-7,8.4A1.561,1.561,0,0,1,1.406,8.4L3.842,7,5.4,9.7,2.969,11.111a1.564,1.564,0,0,1-2.134-.572Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    d: "M3.312,9.83a.313.313,0,0,0-.427-.114l-.541.312a.313.313,0,0,1-.427-.114.312.312,0,0,0-.541.313.939.939,0,0,0,1.281.343l.541-.312a.313.313,0,0,0,.114-.427Zm0,0",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Path 12138",
    d: "M15.536,1.367l-1.741.969a.313.313,0,0,0,.3.546l1.741-.969a.312.312,0,0,0-.3-.546Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Path 12139",
    d: "M15.353,4.6,14.146,4.28a.312.312,0,1,0-.162.6l1.208.323a.312.312,0,1,0,.162-.6Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12140",
    "data-name": "Path 12140",
    d: "M12.319.232l-.324,1.208a.313.313,0,0,0,.6.162L12.922.394a.312.312,0,1,0-.6-.162Zm0,0",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnoncement);
export default __webpack_public_path__ + "static/media/annoncement.5fc5a5b4db98b8e9f128e911198d5187.svg";
export { ForwardRef as ReactComponent };